module.exports = __webpack_public_path__ + "94ad05a76056fa4bd9578164929c30db.svg";